'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _grid = require('../components/grid.directive');

var _grid2 = _interopRequireDefault(_grid);

var _user = require('../api/user.service');

var _user2 = _interopRequireDefault(_user);

var _asset = require('../api/asset.service');

var _asset2 = _interopRequireDefault(_asset);

var _customer = require('../api/customer.service');

var _customer2 = _interopRequireDefault(_customer);

var _asset3 = require('./asset.routes');

var _asset4 = _interopRequireDefault(_asset3);

var _asset5 = require('./asset.controller');

var _assignToCustomer = require('./assign-to-customer.controller');

var _assignToCustomer2 = _interopRequireDefault(_assignToCustomer);

var _addAssetsToCustomer = require('./add-assets-to-customer.controller');

var _addAssetsToCustomer2 = _interopRequireDefault(_addAssetsToCustomer);

var _asset6 = require('./asset.directive');

var _asset7 = _interopRequireDefault(_asset6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.asset', [_angularUiRouter2.default, _grid2.default, _user2.default, _asset2.default, _customer2.default]).config(_asset4.default).controller('AssetController', _asset5.AssetController).controller('AssetCardController', _asset5.AssetCardController).controller('AssignAssetToCustomerController', _assignToCustomer2.default).controller('AddAssetsToCustomerController', _addAssetsToCustomer2.default).directive('tbAsset', _asset7.default).name;


// WEBPACK FOOTER //
// ./src/app/asset/index.js